import React from 'react';
import './CommonEvents.css';

const CommonEvents = ({ topEvents, homeTeamName, awayTeamName }) => {
    return (
        <div className="stats-section">
            <h3 className="stats-section-title">Most Common Events</h3>
            <div className="common-events">
                {topEvents.map(event => (
                    <div key={event.type} className="event-stat">
                        <div className="event-name">{event.type}</div>
                        <div className="event-count">{event.total}</div>
                        <div className="event-team-split">
                            <div
                                className="event-home"
                                style={{
                                    width: `${event.home / event.total * 100}%`
                                }}
                            ></div>
                            <div
                                className="event-away"
                                style={{
                                    width: `${event.away / event.total * 100}%`
                                }}
                            ></div>
                        </div>
                        <div className="event-team-labels">
                            <div className="event-home-label">
                                {event.home} {homeTeamName}
                            </div>
                            <div className="event-away-label">
                                {event.away} {awayTeamName}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CommonEvents;